export const userMenuRouter = [
  {
    path: "userstate",
    name: "userstate",
    component: (resolve) => require(["../views/User/userstate.vue"], resolve),
    meta: {
      title: "报名状态查询",
      islogin:true,
    },
  },
  {
    path: "userinfo",
    name: "userinfo",
    component: (resolve) => require(["../views/User/userinfo.vue"], resolve),
    meta: {
      title: "个人信息",
      islogin:true,
    },
  },
  {
    path: "userWork",
    name: "userWork",
    component: (resolve) => require(["../views/User/userworks.vue"], resolve),
    meta: {
      title: "报名信息",
      islogin:true,
    },
  },
  {
    path: "usercourse",
    name: "usercourse",
    component: (resolve) => require(["../views/User/usercourse.vue"], resolve),
    meta: {
      title: "我的课程",
      islogin:true,
    },
  },
  {
    path: "userexam",
    name: "userexam",
    component: (resolve) => require(["../views/User/userexam.vue"], resolve),
    meta: {
      title: "我的考试",
      islogin:true,
    },
  },
];

export const menuRouter = [
  {
    path: "/Home",
    name: "Home",
    component: () => import("../views/Home/Home.vue"),
    meta: {
      title: "报名入口",
    },
  },
  {
    path: "/Notice",
    name: "Notice",
    component: () => import("../views/Notice/notice.vue"),
    meta: {
      title: "活动通知",
    },
  },
  {
    path: "/WorkShow",
    name: "WorkShow",
    component: () => import("../views/WorkShow/WorkShow.vue"),
    meta: {
      title: "操作视频",
    },
  },
  {
    path: "/Course",
    name: "Course",
    component: () => import("../views/Course/course.vue"),
    meta: {
      title: "课程学习",
    },
  },
  {
    path: "/Exam",
    name: "Exam",
    component: () => import("../views/Exam/exam.vue"),
    meta: {
      title: "考试测评",
    },
  },
  {
    path: "/Help",
    name: "Help",
    component: () => import("../views/Help/help.vue"),
    meta: {
      title: "帮助中心",
    },
  },
  {
    path: "/User",
    name: "User",
    component: () => import("../views/User/user.vue"),
    meta: {
      title: "个人中心",
      islogin:true,
    },
    children: [...userMenuRouter],
  },
];
